<div class="grid-x">
    <div class="cell small-12">
        Replace bonding is a generic handler for creating a bonding replacement entry, rather than rewriting the entire financial instrument just to replace it.
    </div>
    <div class="cell small-6 padding-right bold">
        Replaced Bond ID Context:
    </div>
    <div class="cell small-6">
        <input type="text" [(ngModel)]="replacedBondContext" />
    </div>
    <div class="cell small-6 padding-right bold">
        Replacing Bond ID Context:
    </div>
    <div class="cell small-6">
        <input type="text" [(ngModel)]="replacingBondContext" />
    </div>
</div>